export class RealTimeOrderRecordingIsNotLive extends Error {
  constructor() {
    super('RealTime recording for this order is not live')
    Object.setPrototypeOf(this, RealTimeOrderRecordingIsNotLive.prototype)
  }
}
